import {handleActions} from 'redux-actions'
import {omit} from 'lodash'
import * as actions from './actions'

const initialState = {
  isFetching: true,
  entities: {},
}

const reducer = handleActions(
  {
    [actions.fetch.requested]: (
      state,
    ) => ({
      ...state,
      isFetching: true
    }),
    [actions.fetch.succeeded]: (
      state,
      {
        payload: {
          entities: {messages},
        },
      }
    ) =>  ({
      ...state,
      isFetching: false,
      entities: messages
    }),

    [actions.create.succeeded]: (
      state,
      {
        payload: {
          entities: {messages},
        },
      }
    ) => ({
      ...state,
      entities: {
        ...state.entities,
        ...messages,
      },
    }),

    [actions.remove.succeeded]: (state, {payload: id}) => ({
      ...state,
      entities: omit(state.entities, id),
    }),

    [actions.fetchTemplates.succeeded]: (
      state,
      {
        payload: {
          response
        },
      }
    ) => ({
      ...state,
      templates: response
    }),

    [actions.update.succeeded]: (
      state,
      {
        payload: {
          entities: {messages},
        },
      }
    ) => ({
      ...state,
      entities: {
        ...state.entities,
        ...messages,
      },
    }),

    [actions.getComments.succeeded]: (state, {payload: {messageId, response}}) => ({
      ...state,
      entities: {
        ...state.entities,
        [messageId]: {
          ...state.entities[messageId],
          comments: response
        }
      },
    }),
  },
  initialState
)

export default reducer
